import DevExpress from 'devextreme/bundles/dx.all';

// tslint:disable-next-line: no-empty-interface
export interface Chart extends DevExpress.viz.dxChart {}
// tslint:disable-next-line: no-empty-interface
export interface ChartConfig extends DevExpress.viz.dxChartOptions {}
// tslint:disable-next-line: no-empty-interface
export interface ChartSeries extends DevExpress.viz.ChartSeries {}

export interface SeriesColorScheme {
    color: string;
    hoverColor: string;
}

export enum ChartZoom {
    ONE_OUR = 14,
    TWO_OURS = 14,
    THREE_OURS = 13,
    SIX_OURS = 12,
    TWELVE_OURS = 11,
    DAY = 10,
    // 2_2_3_Days = 9
    // 3_4_Days = 8
    WEEK = 7,
    TWO_WEEKS = 6,
    MONTH = 5,
}
